import { isPlatformBrowser } from '@angular/common';
import { InjectionToken, PLATFORM_ID, type Provider } from '@angular/core';

export const STAFF_HTTP_API_BASE_URL = new InjectionToken<string>(
  'STAFF_HTTP_API_BASE_URL',
);

/**
 * `getBaseUrl` 은 SSR 렌더 중에는 호출되지 않는다(브라우저가 아니면 빈 문자열을 그대로 provide) —
 * 각 앱의 `environment.*ApiBaseUrl` 필드명이 서로 달라 팩토리로 흡수한다.
 */
export function provideStaffHttpApiBaseUrl(getBaseUrl: () => string): Provider {
  return {
    provide: STAFF_HTTP_API_BASE_URL,
    useFactory: (platformId: object) =>
      isPlatformBrowser(platformId) ? getBaseUrl() : '',
    deps: [PLATFORM_ID],
  };
}
